import {peakAlert} from "../PeakDialog.js";
import jQuery from "jquery";
import {ZIDX} from "../standalone/standaloneLibrary.js";
import {ZIDXPagination, ZIDXPaginationOptions} from "../standalone/pagination.js";

let $=jQuery.noConflict();

export class ZIDXAccountListView {
    searchURL:string="";
    token:string="";
    formElement:HTMLFormElement|null=null;
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
        let form=$(".zidxPageActive .zidxSearchListViewForm", this.zidx.peakidxShadowRoot);
        if(form.length>0) {
            this.formElement = <HTMLFormElement>form[0];
            this.token = this.formElement.id.replace("zidxSearchListViewForm", "");
        }
    }
    render(){
        if(this.formElement==null){
            return;
        }
        let self=this;
        $(this.formElement as HTMLElement).on("submit", function(this, e:JQuery.SubmitEvent){
            e.preventDefault();
            $("input[name='offset']", this).val(0);
            self.loadData(this.id, (this as HTMLFormElement).action);
            $(".zidxSearchListViewShowAll", this).css("display", "inline-block");
        });
        $(".zidxSearchListViewShowAll", this.formElement).on("click", function(this, e){
            e.preventDefault();
            this.style.display="none";
            self.zidx.loadPushStateURL((this as HTMLAnchorElement).href, false);
        });
        $(window).off("popstate.zidxAccountListView").on("popstate.zidxAccountListView", function (e:any) {
            let state=(<PopStateEvent>e.originalEvent).state;
            if(!state || typeof state.zidxToken=="undefined" || state.zidxToken!=self.token) {
                return;
            }
            $(".zidxFooterDisclaimerContainer", self.zidx.peakidxShadowRoot).css({"float": "left", "width": "100%"});
            $("#zidxSearchListViewBody"+state.zidxToken, self.zidx.peakidxShadowRoot).each(function(this:HTMLElement){
                this.outerHTML=state.data;
            });
            self.setFormData(state.search);
            self.drawPageNav("zidxPaginationContainer"+state.zidxToken, self.searchURL, parseInt(state.search.count) ,parseInt(state.search.limit), parseInt(state.search.offset));
        });

        // store initial page state
        let search=this.getFormData();
        let initialBody=$("#zidxSearchListViewBody"+this.token, this.zidx.peakidxShadowRoot)[0];
        history.replaceState({
            // disableSPABack:true,
            search:search,
            token:this.token,
            data:initialBody ? initialBody.outerHTML : ""
        }, document.title, document.location.href);

        this.drawPageNav("zidxPaginationContainer"+this.token, this.searchURL, parseInt(search.count) ,parseInt(search.limit), parseInt(search.offset));
    }
    loadData(id:string, url:string){
        let self=this;
        let postObj=this.zidx.getFormDataByFormId(id);
        postObj.token=this.token;
        let qs=[];
        for(let i in postObj){
            qs.push(i+"="+encodeURIComponent(postObj[i]));
        }
        let tempURL=url+"?"+qs.join("&");
        $(".zidxPageContainer.zidxPageActive", this.zidx.peakidxShadowRoot).attr("data-last-url", tempURL);
        let obj = {
            id: "ajaxSearchListView",
            method: "get",
            ignoreOldRequests: true,
            callback: function(r:string){
                let rs;
                try{
                    rs=JSON.parse(r);
                }catch(e){
                    peakAlert("Search failed, please try again later");
                    return;
                }
                if(rs.success) {
                    self.zidx.peakidxShadowRoot.getElementById("zidxSearchListViewBody"+postObj.token)!.outerHTML=rs.data;
                    window.history.pushState({
                        // disableSPABack:true, // don't do this on first view
                        token:postObj.token,
                        search:self.getFormData(),
                        data:rs.data
                    }, document.title, tempURL);

                    self.drawPageNav("zidxPaginationContainer"+postObj.token, url, rs.count, parseInt(postObj.limit), parseInt(postObj.offset));
                }else{
                    peakAlert("Search failed, please try again later");
                }
            },
            errorCallback: function(r:string){
                peakAlert("Search failed, please try again later");
            },
            url: tempURL+"&ajaxLoad=1"
        };
        this.zidx.ajaxRequest(obj);

    }

    drawPageNav(containerId:string, url:string, count:number, perpage:number, offset:number){
        // if(this.zidx.options.debug) console.log("draw pagenav: "+count+":"+perpage+":"+offset);
        let options=new ZIDXPaginationOptions();
        options.id=containerId;
        options.count=count;
        options.perpage=perpage;
        options.offset=offset;
        let self=this;
        options.loadFunction=function(options:any){
            $("input[name='offset']", self.formElement as HTMLElement).val(options.offset);
            self.loadData("zidxSearchListViewForm"+self.token, url);
        }
        let p=new ZIDXPagination(options, this.zidx);
    }
    getFormData(){
        let search:any={};
        $("input", this.formElement as HTMLElement).each(function(this:HTMLElement){
            if(this instanceof HTMLInputElement) {
                if(this.type=="checkbox" || this.type=="radio") {
                    search[this.name]=this.checked;
                }else {
                    search[this.name] = this.value;
                }
            }
        });
        $("textarea", this.formElement as HTMLElement).each(function(this:HTMLElement){
            if(this instanceof HTMLTextAreaElement) {
                search[this.name] = this.value;
            }
        });
        $("select", this.formElement as HTMLElement).each(function(this:HTMLElement){
            if(this instanceof HTMLSelectElement) {
                search[this.name] = this.selectedIndex;
            }
        });
        return search;
    }
    setFormData(search:any){
        $("select, textarea, input", this.formElement as HTMLElement).each(function(this:HTMLElement){
            if(this instanceof HTMLInputElement) {
                for (let field in search) {
                    if (this.name == field) {
                        if (this.type == "checkbox" || this.type == "radio") {
                            this.checked = search[field];
                        } else {
                            this.value = search[field];
                        }
                        break;
                    }
                }
            }else if(this instanceof HTMLTextAreaElement){
                for (let field in search) {
                    if (this.name == field) {
                        this.value = search[field];
                        break;
                    }
                }
            }else if(this instanceof HTMLSelectElement) {
                for (let field in search) {
                    if (this.name == field) {
                        this.selectedIndex = search[field];
                        break;
                    }
                }
            }
        });
    }
}